import React, { useEffect, useRef, useState } from "react";
import { translate } from '../Services/translation';

export default function ShowMore(props) {
    let ref = useRef(0);
    const [overflow, setOverflow] = useState(false);
    const [showToggleBtn, setShowToggleBtn] = useState(false);
    useEffect(() => {
        const current = ref.current;
        if (current.getBoundingClientRect().height > 48) {
            setOverflow(true);
            setShowToggleBtn(true);
        }
    }, []);

    const toggle = () => {
        setOverflow(!overflow);
    };

    return (
        <div className="show-more">
            <p
                className={`show-more__text ${overflow ? "is-long" : ""}`}
                style={showToggleBtn ? { marginBottom: "2rem" } : {}}
                ref={ref}
            >
                {props.text}
            </p>
            {showToggleBtn && (
                <button onClick={toggle} className="show-more__trigger">
                    {overflow && translate('general.show.more') }
                    {!overflow && translate('general.show.less') }
                </button>
            )}
        </div>
    );
}
